import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Agenda da Escola',
    path: '/calendario/agenda',
    name: 'agenda',
    component: () => import('@/views/calendario/agenda/AgendaIndex.vue'),
    meta: {
      permissions: [eTipoPermissao.AGENDA_MENU_200600000],
    },
    goesToMenu: true,
  },
];
